'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RadioGroup } from '@headlessui/react'

import { updateSearchParams, getSearchParams, removeSearchParam } from "@utils";
import { sortTypes } from '@constants';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai'
import tailwindConfig from '@tailwind.config'

const SortFilter = ({ title, dictionary, lang }) => {
    const router = useRouter();
    let [sort, setSort] = useState('datedesc')
    let [addChecked, setAddChecked] = useState(sortTypes[lang][0].value)


    const handleUpdateParams = (e) => {
        let newPathName
        if (e.value == 0) {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateSearchParams(title, e.value);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const sortValue = getSearchParams('sort')
        setAddChecked(sortValue)
        const newValue = sortTypes[lang].find(obj => obj.value === addChecked);

        if (newValue != undefined) {
            setSort(newValue)
        } else {
            setSort(sortTypes[lang][0])
        }

    }, [handleUpdateParams])

    return (
        <div className="w-full flex flex-row items-center px-1">
            <div className='w-1/4'>
                <span className='text-sm text-secondary'>{dictionary.filter.orderBy}:</span>
            </div>
            <div className="w-3/4">
                <RadioGroup value={sort} onChange={(value) => {
                    setSort(value)
                    handleUpdateParams(value)
                }}
                    className='w-full py-1 mt-1 flex flex-row'
                >
                    <RadioGroup.Option
                        key={sortTypes[lang][0].value}
                        value={sortTypes[lang][0]}
                        checked={sortTypes[lang][0] === sort}
                        className={({ active, checked }) =>
                            `${active
                                ? ''
                                : ''
                            }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                            }
                                    w-1/3 relative flex cursor-pointer rounded-lg px-2 py-2 shadow-md focus:outline-none`
                        }
                    >
                        {({ active, checked }) => (
                            <>
                                <div className="flex w-full items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="text-sm text-center">
                                            <RadioGroup.Label
                                                as="p"
                                                className={`font-medium w-full  ${checked ? 'text-light' : 'text-maincolor'
                                                    }`}
                                            >
                                                {sortTypes[lang][0].title}
                                            </RadioGroup.Label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </RadioGroup.Option>
                    <RadioGroup.Option
                        key={sortTypes[lang][1].value}
                        value={sortTypes[lang][1]}
                        checked={sortTypes[lang][1] === sort}
                        className={({ active, checked }) =>
                            `${active
                                ? ''
                                : ''
                            }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                            }
                                    w-1/3 relative flex cursor-pointer rounded-lg px-2 py-2 shadow-md focus:outline-none`
                        }
                    >
                        {({ active, checked }) => (
                            <>
                                <div className="flex w-full items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="text-sm text-center">
                                            <RadioGroup.Label
                                                as="p"
                                                className={`font-medium w-full flex flex-row items-center  ${checked ? 'text-light' : 'text-maincolor'
                                                    }`}
                                            >
                                                <span className='mr-1'>{dictionary.filter.price}</span>
                                                <AiOutlineArrowUp
                                                    color={checked ? tailwindConfig.theme.extend.colors.light : tailwindConfig.theme.extend.colors.secondary}
                                                />
                                            </RadioGroup.Label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </RadioGroup.Option>
                    <RadioGroup.Option
                        key={sortTypes[lang][2].value}
                        value={sortTypes[lang][2]}
                        checked={sortTypes[lang][2] === sort}
                        className={({ active, checked }) =>
                            `${active
                                ? ''
                                : ''
                            }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                            }
                                    w-1/3 relative flex cursor-pointer rounded-lg px-2 py-2 shadow-md focus:outline-none`
                        }
                    >
                        {({ active, checked }) => (
                            <>
                                <div className="flex w-full items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="text-sm text-center">
                                            <RadioGroup.Label
                                                as="p"
                                                className={`font-medium w-full flex flex-row items-center ${checked ? 'text-light' : 'text-maincolor'
                                                    }`}
                                            >
                                                <span className='mr-1'>{dictionary.filter.price}</span>
                                                <AiOutlineArrowDown
                                                    color={checked ? tailwindConfig.theme.extend.colors.light : tailwindConfig.theme.extend.colors.secondary}
                                                />
                                            </RadioGroup.Label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </RadioGroup.Option>
                </RadioGroup>
            </div>
        </div>
    )
}

export default SortFilter